<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Job Grade Code"
      text="Edit Job Grade Code"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localJobGrade.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="localJobGrade.salary_from"
                v-validate="'required|twoDecimalValue'"
                v-money="money"
                :error-messages="errors.collect('salary_from')"
                data-vv-name="salary_from"
                data-vv-as="salary from"
                label="Salary From"
                outlined
                prefix="RM"
                :min="0"
                @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="localJobGrade.salary_to"
                v-validate="'required|twoDecimalValue'"
                v-money="money"
                :error-messages="errors.collect('salary_to')"
                data-vv-name="salary_to"
                data-vv-as="salary to"
                label="Salary To"
                outlined
                prefix="RM"
                :min="0"
                @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="px-10 white--text"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  import Big from 'big.js'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      jobGrade: {
        type: Object,
        default: null,
      },  
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localJobGrade: null,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.localJobGrade = { ...this.jobGrade }
        this.localJobGrade.salary_from = (Math.round((this.localJobGrade.salary_from / 100) * 100) / 100).toFixed(2) 
        this.localJobGrade.salary_to = (Math.round((this.localJobGrade.salary_to / 100) * 100) / 100).toFixed(2) 
      },
    },
    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },
    methods: {
      prepareFormData () {
        return {
          name: this.localJobGrade.name,
          salary_from: this.localJobGrade.salary_from.toString().replaceAll(',', ''),
          salary_to: this.localJobGrade.salary_to.toString().replaceAll(',', ''),
        }
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.jobGrades().update(this.localJobGrade.id, this.prepareFormData())
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      isValidNumbers (value) {
        value = value.toString().replaceAll(',', '')
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>
